<template>
    <div class="angebot__item  mt-4 border">
        <div class="angebot__item--inner  row">
            <div class="col-2 border-right inner__item font-weight-bold icons">
                <img src="@/assets/icons/icon_freigegeben.svg" v-if="Angebot.freigegeben == 1 && Angebot.aktiv == 1 && Angebot.zur_bearbeitung == 0">
                <img src="@/assets/icons/icon_abgelehnt.svg" v-else-if="Angebot.abgelehnt == 1">
                <img src="@/assets/icons/icon_bearbeitung.svg" v-else-if="Angebot.zur_bearbeitung == 1">
                <img src="@/assets/icons/icon_ausstehend.svg" v-else-if="Angebot.aktiv == 1 && Angebot.freigegeben == 0">
                <img src="@/assets/icons/icon_deaktiviert.svg" v-else-if="Angebot.aktiv == 0">
            </div>
            <div class="col-2 border-right inner__item font-weight-bold">
                {{ Angebot.zimmergroesse }}m²
            </div>
            <div class="col-3 border-right inner__item font-weight-bold">
                <span v-for="art in arten" v-bind:key="art.value"><span v-if="art.value == Angebot.zimmerart">{{ art.text}}</span></span>
            </div>
            <div class="col-3 inner__item font-weight-bold">
                {{ Angebot.ort }}
            </div>
            <div class="col-2 toggle__actions py-5" >
                <mdb-icon  icon="bars" class="red-text" size="2x" v-bind:class="{active: overlay == true}" @click.native.prevent="overlay = !overlay" v-if="!overlay" />
                <mdb-icon  icon="times" class="red-text" size="2x" v-bind:class="{active: overlay == true}" @click.native.prevent="overlay = !overlay" v-if="overlay" />
                <div class="info" v-if="Angebot.kommentar != '' && Angebot.kommentar != null && Angebot.kommentar_gesehen == 0" v-bind:class="{active: overlay == true}">1</div>
                <div class="color__overlay" v-bind:class="{active: overlay == true}"><div class="part part__1"></div><div class="part part__2"></div> </div>

            </div>

            <div class="angebot__item--overlay d-flex justify-content-between align-items-center" v-bind:class="{active: overlay == true}">
                <div class="overlay__item">
                    <a v-on:click="openModal(Angebot.persistence_object_identifier)">
                        <div class="overlay__item--headline">Vorschau</div>
                        <div class="overlay__item--description">Ihr Wohnungsangebot</div>
                    </a>
                </div>
                <div class="overlay__item">
                    <router-link class="angebot-link" :to="{name: 'angebotBearbeiten', params: {angebotToEdit: Angebot, id: Angebot.persistence_object_identifier}}">
                    <div class="overlay__item--headline">Bearbeiten</div>
                    <div class="overlay__item--description">Bearbeiten Sie<br> Ihr Wohnungsangebot</div>
                    </router-link>
                </div>
                <div class="overlay__item position-relative" v-if="Angebot.kommentar != '' && Angebot.kommentar != null && Angebot.kommentar_gesehen == 0" >
                    <a v-on:click="openKommentarVorhanden(Angebot.persistence_object_identifier)">
                        <div class="info">1</div>
                        <div class="overlay__item--headline">Kommentar</div>
                        <div class="overlay__item--description">Ein neuer Kommentar<br> wurde hinzugefügt</div>
                    </a>
                </div>
                <div class="overlay__item position-relative" v-else >
                    <template v-if="Angebot.kommentar != '' && Angebot.kommentar != null && Angebot.kommentar_gesehen == 1">
                        <a v-on:click="openKommentarVorhanden(Angebot.persistence_object_identifier)">
                            <div class="overlay__item--headline">Kommentar</div>
                            <div class="overlay__item--description">Kein neuer Kommentar</div>
                        </a>
                    </template>
                    <template v-else>
                            <div class="overlay__item--headline">Kommentar</div>
                            <div class="overlay__item--description">Kein Kommentar vorhanden</div>
                    </template>

                </div>
              <div class="overlay__item">
                <a v-on:click="confirmDeactivateAngebot(Angebot.persistence_object_identifier)">
                  <div class="overlay__item--headline">Deaktivieren</div>
                  <div class="overlay__item--description">Deaktivieren Sie<br> das Wohnungsangebot</div>
                </a>
              </div>
                <div class="overlay__item">
                    <a v-on:click="confirmDeleteAngebot(Angebot.persistence_object_identifier)">
                        <div class="overlay__item--headline">Löschen</div>
                        <div class="overlay__item--description">Löschen Sie<br> das Wohnungsangebot</div>
                    </a>
                </div>
            </div>
        </div>
        <div class="kommentar__dimmer" v-if="kommentarAktiv"></div>
        <div class="kommentar__field" v-if="kommentarAktiv">
            <textarea v-model="kommentar" rows="10" class="disabled form-control md-textarea border-none"></textarea>
            <div class="d-flex justify-content-between">
                <mdb-btn  color="primary" @click.native.prevent="closeKommentar">Schließen</mdb-btn>
            </div>

        </div>
        <div class="confirm__remove" v-bind:class="{'active': confirm == true || confirmDeactivate == true}">
            <div class="inner d-flex justify-content-center align-items-center flex-column">
                <h2 class="text-center" v-if="confirm">Sind Sie sicher, dass Sie das Inserat löschen möchten?</h2>
                <h2 class="text-center" v-if="confirmDeactivate">Sind Sie sicher, dass Sie das Inserat deaktivieren möchten?</h2>

                <div class="d-flex mt-5" v-if="confirm">
                    <div class="btn btn-outline-danger" v-on:click="confirmRemove(true)">löschen</div>
                    <div class="btn btn-outline-danger" v-on:click="confirmRemove(false)">abbrechen</div>
                </div>
              <div class="d-flex mt-5" v-if="confirmDeactivate">
                <div class="btn btn-outline-danger" v-on:click="confirmDeactivated(true)">deaktivieren</div>
                <div class="btn btn-outline-danger" v-on:click="confirmDeactivated(false)">abbrechen</div>
              </div>
            </div>
        </div>
        <Show :Angebot="Angebot" :modalActive="modalActive" :isAufMerkliste="isAufMerkliste" :listOrte="listOrte"></Show>
    </div>
</template>

<script>
    import Show from "@/components/angebot/vermieter/ShowVermieter";
    import settings from '@/components/Settings.json';
    import AngebotService from "@/services/AngebotService";
    import EmailService from "@/services/EmailService";
    import ImageService from "@/services/ImageService.js";
    import Lightbox from "@/components/Lightbox";
    import {mapGetters} from "vuex";
    export default {
        name: "AngebotItem",
        components: {
            Show,
            Lightbox
        },
        data() {
            return {
                arten: settings.Settings[1][this.$store.getters.lang][0].Zimmerarten,
                modalActive: false,
                isSelected: false,
                isAufMerkliste: true,
                kommentarAktiv: false,
                kommentar: "",
                selectedAngebot: "",
                overlay: false,
                confirm: false,
                confirmDeactivate: false,
                lightbox: false,
                lightboxImages: [],
                publicPath: process.env.BASE_URL,

            };
        },
        props: {
            Angebot: Object,
            listOrte: Array,
        },
        methods:{
          toggleLightbox(images){
                this.lightbox = !this.lightbox;
                this.lightboxImages = images;
            },
            deleteAngebot(id){
                let this_ = this;
                AngebotService.deleteAngebotSelf(id).then(function(){
                  this_.confirm = false;
                  this_.confirmDeactivate = false;
                  this_.overlay = false;
                   this_.$parent.emitChange();
                    ImageService.deleteImages(id).then(function(){

                    }).catch(function(){
                      // ERROR
                    });
                }).catch(function(){
                  // ERROR
                });
            },
            deactivateAngebot(id){
              let this_ = this;
              AngebotService.setAngebotStatus(id, "aktiv", 0).then(response => {
                this_.confirm = false;
                this_.confirmDeactivate = false;
                this_.overlay = false;
                console.log("deactivate")

                this_.$parent.emitChange();
              }).catch(function(){
                // ERROR
              });
            },
            confirmDeactivateAngebot(id){
                this.confirmDeactivate = true;
            },
            confirmDeleteAngebot(id){
                this.confirm = true;
            },
            closeKommentar(){
                this.kommentarAktiv = false;
                this.kommentar = "";
                this.selectedAngebot = "";
            },
            openModal(){
                this.modalActive = true;
            },
            closeModal(){
                this.modalActive = false;
            },
            aufMerkliste(){
                this.isSelected = true;
            },
            openKommentarVorhanden(id){
                this.kommentarAktiv = true;
                this.kommentar = this.Angebot.kommentar;
                AngebotService.setAngebotStatus(this.Angebot.persistence_object_identifier, "kommentar_gesehen", 1);
                this.Angebot.kommentar_gesehen = 1;
                this.selectedAngebot = id;
            },
            selectOrt(key) {
              if(!key){return}
                key = key.replace(/ /g,'');
                this.places.forEach(option => {
                    if(option.value == key){
                        option.selected = true;
                        this.Angebot.ort = option.text;
                    }
                });
            },
            confirmRemove(state){
                if(state){
                    this.confirm = false;
                    this.deleteAngebot(this.Angebot.persistence_object_identifier);
                } else {
                    this.confirm = false;
                }
            },
          confirmDeactivated(state){
            if(state){
              this.confirmDeactivate = false;
              this.deactivateAngebot(this.Angebot.persistence_object_identifier);
            } else {
              this.confirmDeactivate = false;
            }
          }
        },
        updated() {
            if(this.Angebot.ort){
                this.selectOrt(this.Angebot.ort);
            }
            if(this.Angebot.length > 0){
              //TODO: ??
            }
        },
      computed:{
        ...mapGetters([
          'places',
        ])
      },
        mounted: function () {
            this.arten = settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;

        }
    }
</script>

<style scoped>

</style>